export type ServicesType = {
  id: string | number
  value: string
  imgUrl: string
}

export const serviceProviders: ServicesType[] = [
  {
    id: '1',
    value: 'moonPay',
    imgUrl: '/assets/wallet/moonpay.svg',
  },
  {
    id: '2',
    value: 'chainBits',
    imgUrl: '/assets/wallet/chainbits.svg',
  },
  {
    id: '3',
    value: 'payBis',
    imgUrl: '/assets/wallet/paybis.svg',
  },
  {
    id: '4',
    value: 'visa',
    imgUrl: '/assets/wallet/visa-master-card.svg',
  },
]
